// extracted by mini-css-extract-plugin
export default {"realDealCard":"RealDealModal_realDealCard__1LlZx","trdIframeWrapper":"RealDealModal_trdIframeWrapper__wkiHQ","iframeRow":"RealDealModal_iframeRow__02ieq"};